import { z } from "zod";
import { SUPPORTED_LANGUAGES } from "../constants/languages";
export const publicSubmissionSchema = z.object({
    qrRouteId: z.string().uuid(),
    surveyId: z.string().uuid(),
    surveyVersionId: z.string().uuid(),
    clientGeneratedId: z.string().uuid().optional(),
    language: z.enum(SUPPORTED_LANGUAGES),
    unitCode: z.string().max(80).optional(),
    roomNumber: z.string().max(80).optional(),
    contactName: z.string().trim().max(160).optional(),
    contactEmail: z.string().email().max(255).optional(),
    contactPhone: z.string().max(80).optional(),
    contactPermission: z.boolean().default(false),
    clientSubmittedAt: z.string().datetime().optional(),
    answers: z.array(z.object({
        questionId: z.string().uuid().optional(),
        questionKey: z.string().min(1).max(120),
        answerType: z.enum(["numeric", "text", "boolean", "single_choice", "multiple_choice", "matrix"]),
        numericValue: z.number().min(0).max(10).optional(),
        textValue: z.string().max(4000).optional(),
        booleanValue: z.boolean().optional(),
        optionValue: z.string().max(200).optional(),
        rawValue: z.unknown().optional()
    })).min(1).max(80),
    lowScoreFollowUp: z.object({
        triggeredByQuestionKeys: z.array(z.string().min(1).max(120)).max(20).default([]),
        triggeredCategories: z.array(z.string().min(1).max(120)).max(20).default([]),
        selectedReasons: z.array(z.string().min(1).max(120)).max(20).default([]),
        comment: z.string().max(1000).optional(),
        skippedComment: z.boolean().default(false),
        contactPermission: z.boolean().optional()
    }).optional()
});
export const publicPerformanceSchema = z.object({
    qrRouteId: z.string().uuid().optional(),
    surveyVersionId: z.string().uuid().optional(),
    language: z.enum(SUPPORTED_LANGUAGES).optional(),
    ttfbMs: z.number().min(0).max(60_000).optional(),
    lcpMs: z.number().min(0).max(60_000).optional(),
    domContentLoadedMs: z.number().min(0).max(60_000).optional(),
    transferSize: z.number().min(0).max(2_000_000).optional(),
    connectionType: z.string().max(40).optional()
}).refine((value) => (value.ttfbMs !== undefined ||
    value.lcpMs !== undefined ||
    value.domContentLoadedMs !== undefined ||
    value.transferSize !== undefined ||
    value.connectionType !== undefined), { message: "At least one performance metric is required" });
export const publicEventSchema = z.object({
    event: z.enum(["google_review_shown", "google_review_click"]),
    qrRouteId: z.string().uuid().optional(),
    surveyVersionId: z.string().uuid().optional(),
    language: z.enum(SUPPORTED_LANGUAGES).optional(),
    placeId: z.string().max(255).optional()
});
